import { cn } from '@/lib/cn';

export interface SkeletonProps {
  className?: string;
}

/** A single shimmering placeholder block. */
export function Skeleton({ className }: SkeletonProps) {
  return <div aria-hidden="true" className={cn('animate-pulse rounded bg-accent/10', className)} />;
}

/**
 * Suspense fallback for a lazily-loaded route. Mirrors the coarse shape of a
 * page — heading, metric row, two panels — so the layout does not jump when
 * the real page resolves.
 */
export function PageSkeleton() {
  return (
    <div role="status" aria-busy="true" aria-live="polite" className="space-y-3">
      <span className="sr-only">Loading page</span>
      <Skeleton className="h-5 w-64" />
      <div className="grid grid-cols-2 gap-2.5 md:grid-cols-4 xl:grid-cols-7">
        {Array.from({ length: 7 }, (_, index) => (
          <Skeleton key={index} className="h-20" />
        ))}
      </div>
      <div className="grid gap-3.5 lg:grid-cols-2">
        <Skeleton className="h-40" />
        <Skeleton className="h-40" />
      </div>
    </div>
  );
}
